import { render, staticRenderFns } from "./CataloguePagination.vue?vue&type=template&id=34f141b8&scoped=true"
import script from "./CataloguePagination.vue?vue&type=script&lang=js"
export * from "./CataloguePagination.vue?vue&type=script&lang=js"
import style0 from "./CataloguePagination.vue?vue&type=style&index=0&id=34f141b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f141b8",
  null
  
)

export default component.exports